import styled from 'styled-components'

export const PresetsContainer = styled.div`
    padding: 24px 8px 8px 16px;
    font-size: 13px;
    color: ${({ theme }) => theme['gray-800']};

    span {
        font-weight: 700;
    }
`

export const ReportItems = styled.div`
    padding-top: 16px;

    button {
        width: 100%;
        padding-top: 8px;
        padding-bottom: 8px;
        margin-top: 8px;
        font-weight: 400;
        border: none;
        background: transparent;
        text-align: left;
        padding-left: 16px;
    }

    button :hover {
        background: ${({ theme }) => theme['blue-200']};
    }

    .selected {
        background: ${({ theme }) => theme['gray-300']};
    }
`
